import styled from "styled-components";
import BG from "assets/img/bg2.jpg";

export const HeaderMain = styled.header`
    min-height: 100vh;
    background-image: var(--dark-overlay-1), url(${BG});
    background-size: cover;
    background-position: center;
    padding-top: 12vh;
    background-attachment:fixed;
`;

export const Message = styled.div`
    text-align: center;
    width: 100%;
    min-height: 80vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .swiper-pagination {
        bottom: -1.5rem;
    }

    h2 {
        font-size: 3rem;
        font-weight: 500;
        margin-bottom: 1rem;

        span {
            color: var(--main);
            font-weight: 900;
        }
    }

    h3 {
        font-size: 2rem;
        text-align: center;
        width: 100%;

        div {
            width: 100%;
        }
    }
`;
